import { useTranslation } from 'react-i18next'
import { Link, LinkProps } from 'react-router-dom'
import { localizeLinkPath } from '../../router/router-utils'

export const LocalizedLink = (props: LinkProps) => {
  const { i18n } = useTranslation()
  const { language } = i18n

  const linkProps = {
    ...props,
    to: localizeLinkPath(language, props.to) || '',
  }

  return <Link {...linkProps}>{props.children}</Link>
}
